import React, { useEffect, useState } from "react";
import { Form, Button, Tabs, Space, Card, Popconfirm, message } from "antd";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import TableComponent from "../common/table/TableComponent";
import { DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

function VideosTable() {
  const [activeTab, setActiveTab] = useState(2);
  const [confirmDeletePCLoading, setConfirmDeletePCLoading] = useState(false);
  const navigate = useNavigate();

  const columns = [
    {
      title: "Tittle",
      dataIndex: "tittle",
    },
    {
      title: "Path",
      dataIndex: "path",
      render: (text, record) => <a href={text}>Click here to download</a>,
    },
    activeTab == 2
      ? {
          title: "Free",
          dataIndex: "is_free",
          render: (text, record) => <>{text == 1 ? "Yes" : "No"}</>,
        }
      : {
          title: "Subject",
          dataIndex: "subject_name",
        },

    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          {
            <Space>
              <Popconfirm
                title="Delete Video"
                description={`Are you sure to delete this Video?`}
                onConfirm={() => deleteOk(record)}
                trigger={"click"}
                okButtonProps={{
                  loading: confirmDeletePCLoading,
                }}
                placement="rightTop"
              >
                <Button size="small">
                  <DeleteOutlined style={{ color: "red" }} />
                </Button>
              </Popconfirm>
            </Space>
          }
        </>
      ),
    },
  ];

  const [responseData, getRequest] = useApi(
    `/admin/video?pageNumber=1&subscription_type_id=2`,
    null,
    API_METHODS.GET
  );
  const [deleteResponse, deleteRequest] = useApi();

  const [tableData, setTableData] = useState();
  const [form] = Form.useForm();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    const pagination =
      responseData.pagination !== BLANK_VALUE ? responseData.pagination : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [responseData]);

  const deleteOk = (record) => {
    setConfirmDeletePCLoading(true);
    deleteRequest(null, API_METHODS.DELETE, `/admin/video/${record.id}`);
  };

  useEffect(() => {
    if (deleteResponse.data && !deleteResponse.isLoading) {
      getRequest();

      messageApi.open({
        type: "success",
        content: "Video Deleted successfully",
      });
      setConfirmDeletePCLoading(false);
      setActiveTab(2);
    }
  }, [deleteResponse]);

  const onPaginationChange = (page) => {
    getRequest(
      null,
      API_METHODS.GET,
      `/admin/video?pageNumber=${page.current}&subscription_type_id=${activeTab}`
    );
    setCurrentPage(page.current);
  };

  const onTabChange = (key) => {
    setActiveTab(key);
    setCurrentPage(1);
    form.resetFields();

    getRequest(
      null,
      API_METHODS.GET,
      `/admin/video?pageNumber=${1}&subscription_type_id=${key}`
    );
  };

  const handleAddVideos = () => {
    navigate("/portal/videos/upload");
  };

  const items = [
    {
      key: 2,
      label: "GPAT Basic",
      children: (
        <TableComponent
          columns={columns}
          tableData={tableData}
          loading={responseData.isLoading}
          onPaginationChange={onPaginationChange}
          total={totalRecords}
          current={currentPage}
        />
      ),
    },
    {
      key: 3,
      label: "GPAT Advance",
      children: (
        <TableComponent
          columns={columns}
          tableData={tableData}
          loading={responseData.isLoading}
          onPaginationChange={onPaginationChange}
          total={totalRecords}
          current={currentPage}
        />
      ),
    },
  ];

  return (
    <Card
      title="Videos"
      extra={
        <Button type="primary" onClick={handleAddVideos}>
          Upload Videos
        </Button>
      }
    >
      {contextHolder}
      <Tabs activeKey={activeTab} items={items} onChange={onTabChange} />
    </Card>
  );
}

export default VideosTable;
